import { Component } from "react";
import { IconSports } from "../../../../../../components/Icon/Icon";
type Props = {
  sportName: string;
};

class GetSportsIcon extends Component<Props> {
  getSportsIcon = (sportsName: string) => {
    let sportsIcon: any = null;

    switch (sportsName) {
      case "Soccer":
        sportsIcon = <IconSports name="soccer" />;
        break;

      case "American Football":
        sportsIcon = <IconSports name="american-football" />;
        break;

      case "Baseball":
        sportsIcon = <IconSports name="baseball" />;
        break;

      case "Golf":
        sportsIcon = <IconSports name="golf" />;
        break;

      case "Cricket":
        sportsIcon = <IconSports name="cricket" />;
        break;

      case "Boxing":
        sportsIcon = <IconSports name="boxing" />;
        break;

      case "MMA":
        sportsIcon = <IconSports name="boxing" />;
        break;

      case "Basketball":
        sportsIcon = <IconSports name="basketball" />;
        break;

      case "Ice Hockey":
        sportsIcon = <IconSports name="ice-hockey" />;
        break;

      case "Tennis":
        sportsIcon = <IconSports name="tennis" />;
        break;

      case "Esports":
        sportsIcon = <IconSports name="esports" />;
        break;

      default:
        sportsIcon = null;
        break;
    }

    return sportsIcon;
  };

  render() {
    return this.getSportsIcon(this.props.sportName);
  }
}

export default GetSportsIcon as any;
